module.exports = __webpack_public_path__ + "img/maotai.83acfd9c.png";